import {
  FiMail,
  FiPhone,
  FiAward,
  FiUser,
  FiClock,
  FiUsers,
} from "react-icons/fi";
import {
  Body,
  HeaderInfo,
  Section,
  Skill,
  SkillsList,
  StatusMessage,
} from "../../style/view.styles";
import FullButton from "../Buttons/FullButton";
import LoginPrompt from "./LoginPrompt";
import {
  IconContainer,
  MetadataContainer,
  MetadataContent,
  MetadataItem,
  MetadataLabel,
  MetadataValue,
} from "../../style/opportunity.details.style";

const MentorDetailsBody = ({
  mentor,
  user,
  isLoggedIn,
  isApplyModalOpen,
  setIsApplyModalOpen,
  isConnectionSent,
}) => {
  return (
    <Body>
      <HeaderInfo>
        <h1 className="font40 darkGreenColor extraBold">{mentor.fullname}</h1>
      </HeaderInfo>

      <MetadataContainer>
        <MetadataItem>
          <IconContainer>
            <FiAward />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Specializations</MetadataLabel>
            <MetadataValue>
              <SkillsList>
                {mentor.specializations
                  .split(",")
                  .map((specialization, index) => (
                    <Skill key={index}>{specialization.trim()}</Skill>
                  ))}
              </SkillsList>
            </MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiClock />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Availability</MetadataLabel>
            <MetadataValue>{mentor.availability}</MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiMail />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Email</MetadataLabel>
            <MetadataValue>{mentor.email}</MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiPhone />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Phone</MetadataLabel>
            <MetadataValue>{mentor.phone_number}</MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiUsers />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Mentees</MetadataLabel>
            <MetadataValue>{mentor.mentees}</MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiUser />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Rating</MetadataLabel>
            <MetadataValue>⭐ {mentor.rating} / 5</MetadataValue>
          </MetadataContent>
        </MetadataItem>
      </MetadataContainer>

      <Section>
        <h3 className="font24 extraBold">Bio</h3>
        <p className="font18" style={{ padding: "30px 0" }}>
          {mentor.bio}
        </p>
      </Section>
      <Section>
        {isLoggedIn && user.role === "talent" && !isConnectionSent && (
          <FullButton
            action={() => {
              setIsApplyModalOpen(!isApplyModalOpen);
            }}
            title={"Click To Connect"}
          />
        )}
        {isConnectionSent && (
          <StatusMessage type={"success"}>Mentor notified.</StatusMessage>
        )}
        {!isLoggedIn && (
          <LoginPrompt
            message="Please log in to access the application form."
            buttonText="Go To Login"
          />
        )}
      </Section>
    </Body>
  );
};

export default MentorDetailsBody;
